export default __webpack_public_path__ + "static/media/list_view_icon.c254aa6b.svg";